import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import dayjs from "dayjs"; // Ensure you have dayjs imported

const BasicDatePicker = React.forwardRef(
  ({ label, onErrorCheck, control, name, ...props }, ref) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name={name}
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => {
            const isYearPicker = name === "resourcesYear";
            const isDateOnly = name === "onlyDate"; // New case for date selection only

            return (
              <DatePicker
                openTo={isYearPicker ? "year" : "day"} // Year picker opens to year
                views={
                  isYearPicker ? ["year"] : ["year", "month", "day"] // Year picker vs full date
                }
                format={isYearPicker ? "YYYY" : "DD/MM/YYYY"} // Year or full date format
                onChange={onChange}
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "16px",
                    borderRadius: "25px",
                    color: "black",
                    backgroundColor: "white",
                    "& fieldset": { borderColor: "#ccc" },
                    "&:hover fieldset": { borderColor: "#999" },
                  },
                }}
                slotProps={{
                  textField: {
                    helperText: onErrorCheck ? onErrorCheck : "",
                    error: Boolean(onErrorCheck),
                  },
                  field: { clearable: true },
                }}
                value={value ? dayjs(value) : null}
              />
            );
          }}
        />
      </LocalizationProvider>
    );
  }
);

BasicDatePicker.propTypes = {
  onErrorCheck: PropTypes.string,
  control: PropTypes.object.isRequired,
};

export default BasicDatePicker;
